import { render, staticRenderFns } from "./AddCustomerAddress.vue?vue&type=template&id=6f8caf44&scoped=true&"
import script from "./AddCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./AddCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerAddress.vue?vue&type=style&index=0&id=6f8caf44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8caf44",
  null
  
)

export default component.exports